/*
 * @Description: 结算材料管理
 * @Date: 2025-07-16 15:29:41
 */
import { route } from './src/router';

const name = 'settlement-materials';
export { name, route };
